"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "BrowserRouter", {
  enumerable: true,
  get: function get() {
    return _BrowserRouter["default"];
  }
});
Object.defineProperty(exports, "Error", {
  enumerable: true,
  get: function get() {
    return _Error["default"];
  }
});
Object.defineProperty(exports, "context", {
  enumerable: true,
  get: function get() {
    return _application.context;
  }
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Application["default"];
  }
});

var _Error = _interopRequireDefault(require("./components/Error"));

var _application = require("./context/application");

var _Application = _interopRequireDefault(require("./classes/Application"));

var _BrowserRouter = _interopRequireDefault(require("./classes/BrowserRouter"));